// extracted by mini-css-extract-plugin
export var header = "_vd-1";
export var maskBottom = "_vd-6";
export var maskMiddle = "_vd-7";
export var maskTop = "_vd-5";
export var root = "_vd-0";
export var scrollDownButton = "_vd-3";
export var scrollDownButtonHidden = "_vd-4";
export var viewport = "_vd-2";